// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"155":"d4400a10","334":"7b7efed7"}[chunkId] + ".chunk.css";
};